export function gramsToKg(val,precision) {
    return (val / 1000).toFixed(precision)
}

export function kgToGrams(val,precision) {
    return (val * 1000).toFixed(precision)
}

export function epochToDate(epoch) {
    let d = new Date(epoch * 1000);
    return d.toLocaleDateString();
}

export function epochToTime(epoch) {
    let d = new Date(epoch * 1000);
    return d.toLocaleTimeString();
}

export function todayEpochStart(){
    let today = new Date();

    let mth = (today.getMonth() + 1);
    if (mth < 10) {
        mth = "0" + mth;
    }

    let day = (today.getDate());
    if (day < 10) {
        day = "0" + day;
    }

    var defaultDate = today.getFullYear() + '-' + mth + '-' + day;

    let tmpDate = new Date(`${defaultDate} 00:00:00`);
    return tmpDate.getTime() / 1000.0;
}

export function todayEpochEnd() {
    let today = new Date();

    let mth = (today.getMonth() + 1);
    if (mth < 10) {
        mth = "0" + mth;
    }

    let day = (today.getDate());
    if (day < 10) {
        day = "0" + day;
    }

    var defaultDate = today.getFullYear() + '-' + mth + '-' + day;

    let tmpDate = new Date(`${defaultDate} 23:59:59`);
    return tmpDate.getTime() / 1000.0;
}

export function getTodayDate(){
    let today = new Date();

    let mth = (today.getMonth() + 1);
    if (mth < 10) {
        mth = "0" + mth;
    }

    let day = (today.getDate());
    if (day < 10) {
        day = "0" + day;
    }

    let defaultDate = today.getFullYear() + '-' + mth + '-' + day;
    return defaultDate;
}

export function checkNumeric(val){
    const re = /^[0-9\b]+$/;

    if ((val === '' || re.test(val))){
        return true
    }
    else{
        return false
    }
}